import React from 'react'

type Props = {
  width?: number
  height?: number
  color?: string
}

export function BalanceInfiniteIcon({
  width = 68,
  height = 32,
  color = '#FF6480',
}: Props) {
  return (
    <svg viewBox="0 0 2176 1024" width={width} height={height}>
      <path
        d="M1288.64 183.296a488.576 488.576 0 0 1 691.456 0.128 489.28 489.28 0 0 1-0.064 691.52 489.28 489.28 0 0 1-692.096-0.64l-220.8-220.864-221.312 221.44a488.96 488.96 0 0 1-678.912 12.16l-12.672-12.224A488.96 488.96 0 1 1 846.336 183.872l220.8 220.736 221.44-221.248z m-567.808 123.968a312.896 312.896 0 0 0-442.112 443.136 312.96 312.96 0 0 0 442.624 0l221.312-221.376-221.312-221.184z m1134.72 0.512a312.576 312.576 0 0 0-442.496 0v-0.064l-0.064 0.128-221.44 221.12 221.44 221.44 0.448 0.384a313.152 313.152 0 0 0 442.112-0.32 313.28 313.28 0 0 0 0-442.688z"
        fill={color}
      ></path>
    </svg>
  )
}
